












import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/qrcodeLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class QRcodeErrorController extends Vue 
{
    @Prop() layer! : QRcodeLayer;

    private static readonly ERROR_CORRENCTION = ["L(7％)", "M(15％)", "Q(25％)", "H(30％)"];

    private get errorText()
    {
        var error = this.layer.errorCorrection;
        return QRcodeErrorController.ERROR_CORRENCTION[error];
    }

    private changeError()
    {
        var error = this.layer.errorCorrection;
        var newValue = error + 1;
        if(newValue > 3) { newValue = 0; }
        this.changeLayerProperty("errorCorrection", newValue, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
